module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_9016.186e6824.png";